import React from 'react';
import Sidebar from '../sidebar/Sidebar';
import TopNav from '../Dashboard/Top-Nav/TopNav';

function Layout({ children, heading, isDashboardClick }) {
  return (
    <div className="m-0 p-0 box-content max-w-[100dvw] h-[100dvh] bg-[#eceff4] flex justify-center items-center ">
      <div className="min-w-[90vw] h-[97dvh] flex">
        {/* sidebar */}
        <Sidebar isDashboardClick={isDashboardClick} />
        {/* sidebar-end */}
        {/* mainbody */}
        <div className="w-[83vw] h-[100%]  rounded-lg">
          <TopNav heading={heading} />
          {children}
        </div>
        {/* mainbody-end */}
      </div>
    </div>
  );
}

export default Layout;
